<template>
  <div class="home">
	<!-- <router-link to="/user/aaa">yonghu</router-link> -->
    <div class="footer">
		<span >@ {{year}}</span>
		<div class="divide"></div>
		<a href="https://beian.miit.gov.cn/" target="_blank">苏ICP备2024128510号</a>
	</div>
  </div>
</template>

<script>

export default {
  name: 'Home',
  data() {
  	return {
		year:2021
	}
  },
  methods:{
	about(){
		this.$router.push("/home2/index");
	}  
  },
  created() {
  	let date = new Date();
	this.year = date.getFullYear();
  }

}
</script>

<style>
	.home{
		position: absolute;
		height: 100%;
		width: 100%;
		
		background-image: url("../assets/backgroud.jpg");
		background-size: cover;
	}
	.footer{
		display: flex;
		justify-content: center;
		
		position: fixed;
		bottom: 0;
		width: 100%;
		
		height: 40px;
		line-height: 40px;
		text-align: center;
		color: #fff;
		font-family: Arial,serif;
		font-size: 12px;
		letter-spacing: 1px;
	}
	.footer a{
		color: inherit;
		text-decoration: none;
	}
	.divide{
		width: 1px;
		height: 12px;
		background-color: #e5e6eb;
		margin: 14px 12px;
	}
</style>